import { AfterViewInit, Directive, ElementRef, OnDestroy, Renderer2, inject } from '@angular/core';

@Directive({
  selector: '[cipoResizeColumn]',
})
export class ResizeColumnDirective implements AfterViewInit, OnDestroy {
  el = inject(ElementRef);
  renderer = inject(Renderer2);
  private startX = 0;
  private startWidth = 0;
  private tableWidth = 0;
  private handle: HTMLElement;
  private resized = false;

  ngAfterViewInit() {
    const nativeEl = this.el.nativeElement;

    // Add the resize handle
    this.handle = this.renderer.createElement('span');
    this.renderer.addClass(this.handle, 'resize-handle');
    this.renderer.appendChild(nativeEl, this.handle);

    // Apply styling
    this.renderer.setStyle(nativeEl, 'position', 'relative');
    this.renderer.setStyle(nativeEl, 'overflow', 'hidden');

    // Start resize
    this.handle.addEventListener('mousedown', this.onMouseDown);
  }

  onMouseDown = (event: MouseEvent) => {
    event.preventDefault();

    this.resized = false; // Reset resize flag
    this.startX = event.pageX;
    this.startWidth = this.el.nativeElement.offsetWidth;

    const table = this.el.nativeElement.closest('table');
    this.tableWidth = table.offsetWidth;

    document.addEventListener('mousemove', this.onMouseMove);
    document.addEventListener('mouseup', this.onMouseUp);

    // Prevent click after resize
    document.addEventListener('click', this.preventClick, true);
  };

  onMouseMove = (event: MouseEvent) => {
    const deltaX = event.pageX - this.startX;
    if (Math.abs(deltaX) > 2) {
      this.resized = true;
    }

    const newWidthPx = this.startWidth + deltaX;
    let newWidthPercent = (newWidthPx / this.tableWidth) * 100;
    newWidthPercent = Math.max(5, Math.min(95, newWidthPercent)); // clamp between 5% and 95%

    const el = this.el.nativeElement;
    this.renderer.setStyle(el, 'width', `${newWidthPercent}%`);
    this.renderer.setStyle(el, 'minWidth', `${newWidthPercent}%`);
    this.renderer.setStyle(el, 'maxWidth', `${newWidthPercent}%`);
  };

  onMouseUp = (event: MouseEvent) => {
    document.removeEventListener('mousemove', this.onMouseMove);
    document.removeEventListener('mouseup', this.onMouseUp);

    // Delay removal of click preventer slightly to ensure it fires
    setTimeout(() => {
      document.removeEventListener('click', this.preventClick, true);
    }, 0);
  };

  preventClick = (event: MouseEvent) => {
    if (this.resized) {
      event.stopPropagation();
      event.preventDefault();
      this.resized = false; // reset for next interaction
    }
  };

  ngOnDestroy() {
    this.handle?.removeEventListener('mousedown', this.onMouseDown);
    document.removeEventListener('click', this.preventClick, true);
  }
}
